import { Action, Selector, State, StateContext } from "@ngxs/store";
import { TemplateEmail } from "../../models/email-message";
import { Injectable } from "@angular/core";
import { append, patch, removeItem, updateItem } from "@ngxs/store/operators";
import { lastValueFrom } from "rxjs";
import { TemplateEmailStateModel } from "./template-email-model";
import { TemplateEmails } from "./template-email-action";
import { EmailService } from "../../services/email.service";
import { Users } from "../user/user-actions";

@State<TemplateEmailStateModel>
(
    {
        name: "templateEmail",
        defaults:
        {
            templateEmails: [],
            templateEmail: {} as TemplateEmail
        }
    }
)

  @Injectable({ providedIn: 'root' })
  export class TemplateEmailState
  {
    constructor(private _emailService: EmailService){}

    @Selector()
    static templateEmails(state: TemplateEmailStateModel) {
        return state.templateEmails;
    }

    @Selector()
    static templateEmail(state: TemplateEmailStateModel)
    {
        return state.templateEmail;
    }

    @Action(TemplateEmails.LoadEmailTemplates)
    async loadEmailTemplates(ctx: StateContext<TemplateEmailStateModel>)
    {
        const state = ctx.getState();
        return ctx.setState
        (
            { 
                ...state,
                templateEmails: await lastValueFrom(this._emailService.getTemplateEmails()),
             }
        );
    }
    
    @Action([TemplateEmails.EmailServiceEmailTemplateDeleted])
    async EmailTemplateRemoved(ctx: StateContext<TemplateEmailStateModel>, action: TemplateEmails.EmailServiceEmailTemplateDeleted)
    {
        ctx.setState
        (
            patch<TemplateEmailStateModel> ({ templateEmails: removeItem(template => template.id == action.payload.templateEmailId)})
        )
    }

    @Action([TemplateEmails.EmailServiceEmailTemplateSaved])
    async EmailTemplateSaved(ctx: StateContext<TemplateEmailStateModel>, action: TemplateEmails.EmailServiceEmailTemplateSaved)
    {
        ctx.setState
        (
            patch<TemplateEmailStateModel>
            (
                { templateEmails: updateItem(templateEmail => templateEmail.id == action.payload.templateEmail.id, action.payload.templateEmail) }
            )
        )
    }

    @Action([TemplateEmails.EmailServiceEmailTemplateAdded])
    async EmailTemplateAdded(ctx: StateContext<TemplateEmailStateModel>, action: TemplateEmails.EmailServiceEmailTemplateAdded)
    {
        return ctx.setState
        (
            patch<TemplateEmailStateModel>
            (
                { templateEmails: append([action.payload.templateEmail]) }
            )
        )
    }

  }
